import {
  getPricegross,
  offersType,
  planType,
} from '@shared/helpers/function.helpers';
import { Offers } from '@dgx-pr-spa/shared/util';
import { DataLayer } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Description } from '@dgx-pr-spa/shared/util';
import { ItemOffer } from '@dgx-pr-spa/shared/util';

export class GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {}

  get gaCommonData(): DataLayer {
    const offers = this.offers;
    const currentItem = offers?.current_item;
    const customerType = 'G';
    const currentPlan = offers?.current_plan;
    const contact = offers?.contact_details;
    const offer = offers?.offer;
    const selected = this.selected;
    const services = selected?.services;

    const productName =
      currentItem?.make && currentItem?.appliance_category
        ? `${currentItem.make} ${currentItem.appliance_category}`
        : undefined;

    const productNameOffer = `${selected?.make} ${selected?.appliance_category}`;

    const PRGroup = 'aws';

    const installation = services
      ? getPricegross(services, Description.Installation)
      : undefined;
    const disposal = services
      ? getPricegross(services, Description.Disposal)
      : undefined;

    const delivery = services
      ? getPricegross(services, Description.Delivery)
      : undefined;

    const itemOffer = this.itemOffer;

    const PRContinuedCover = offer?.upsell_flag
      ? itemOffer?.subsequentPayment
      : 0;

    const PRContinuedCoverVisible =
      offer?.upsell_flag && itemOffer?.itemOfferHash ? 'Yes' : 'No';

    const showPolicyComparison = !!(
      offers?.current_plan?.dd_amount > itemOffer?.subsequentPayment
    );

    const oldPolicy = `${
      showPolicyComparison ? offers?.current_plan?.dd_amount : 'not available'
    }`;

    const dataLayer: DataLayer = {
      pagename: 'product-replacement-customise-offer',
      category: 'product-replacement',
      genericpagename: 'product-replacement-checkout',
      OfferType: offersType(offers)?.toString(),
      planNumber: currentPlan?.plan_number,
      PlanType: planType(currentPlan),
      customerID: contact?.person_gid,
      JobReferenceNumber: currentPlan?.reference_number,
      productName,
      productModel: currentItem?.model,
      AccountBrand: currentItem?.make,
      Manufacturer: currentItem?.make,
      productNameOffer,
      productModelOffer: selected?.model,
      AccountBrandOffer: selected?.make,
      ManufacturerOffer: selected?.make,
      upgrade: selected?.upgrade_fee,
      outstandingMonthlyPayments: offer?.outstanding_dd_count,
      remainingPayment: offer?.outstanding_dd_amount,
      totalCostReplacement: this.totalCostReplacement,
      installation,
      disposal,
      delivery,
      customerType,
      paymentOffer: 'MPM',
      PRContinuedCover,
      PRContinuedCoverVisible,
      PRGroup,
      rrp: selected?.rrp,
      oldPolicy,
    };

    return dataLayer;
  }
}
export class GAAdditionalServicesPageLoad extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRAWS',
      eventPR: 'product-replacement-customise-offer',
    };

    return dataLayer;
  }
}

export class GAAdditionalServicesExtraSelect extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    private readonly description: Description,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const selected = this.selected;
    const services = selected?.services;

    const description = this.description;

    const installation =
      description === Description.Installation
        ? getPricegross(services, Description.Installation)
        : undefined;
    const disposal =
      description === Description.Disposal
        ? getPricegross(services, Description.Disposal)
        : undefined;

    const eventPR =
      description === Description.Disposal
        ? 'CustomiseDisposalAdd'
        : description === Description.Installation
        ? 'CustomiseInstallationAdd'
        : undefined;

    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR,
      disposal,
      installation,
    };

    return dataLayer;
  }
}

export class GAAdditionalServicesProtectionSelect extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'CustomiseContinueCoverAdd',
    };

    return dataLayer;
  }
}

export class GAAdditionalServicesContinueClick extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }
  get gaData(): DataLayer {
    const offers = this.offers;

    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'Continue',
      imageloaded: 'Yes',
      Category: 'Product Replacement',
      Action: 'Continue',
      Label: offers?.current_plan?.plan_number,
    };

    return dataLayer;
  }
}

export class GAAdditionalServicesPopUpShow extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'popupInstallationDisposalViewed',
      eventCategory: 'Product Replacement',
      eventAction: 'installation-pop-up',
      eventLabel: 'pop-up-viewed',
    };

    return dataLayer;
  }
}
export class GAAdditionalServicesPopUpClose extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    private readonly upsellPopupAction: string,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'popupInstallationDisposal',
      eventCategory: 'product-replacement',
      eventAction: 'installation-pop-up',
      eventLabel: this.upsellPopupAction,
    };

    return dataLayer;
  }
}
export class GAAdditionalServicesToggleBenefits extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number,
    private readonly isOpen: boolean
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'PolicyBenefitsInteraction',
      eventAction: `PolicyBenefitsInteraction`,
      eventCategory: 'Product Replacement',
      eventLabel: `${this.isOpen ? 'expand benefits' : 'colapse benefits'}`,
    };

    return dataLayer;
  }
}

export class GAAdditionalServicesRejectPolicy extends GAAdditionalServicesCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly itemOffer: ItemOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, itemOffer, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'RejectProtectionPolicy',
      eventAction: `RejectProtectionPolicy`,
      eventCategory: 'Product Replacement',
      eventLabel: this.offers?.current_plan?.plan_number,
    };

    return dataLayer;
  }
}
